<template>
    <div class="series-main">
        <div class="series_top">
            <div class="flex-row series_top_left">
                <div class="series_top_title">分卷内容</div>
                <!-- v-if="editType !== 1" -->
                <!-- <div class="cursor_1 series_top_tip" @click="openTip">
                    <img src="@/assets/image/icon_tip.png" class="t-m-r-5" width="18" height="18" alt="">
                    参考格式
                </div> -->
            </div>
            <!-- <textLoading v-if="streamStatus"></textLoading>
            <div class="cursor_1 series_top_center" v-if="!streamStatus && editType == 2">换一换</div> -->
            <div class="series_top_right flex-row">
                <div class="cursor_1 copyText t-m-r-10" @click="copyInnterText">复制内容</div>
                <div class="series_top_num">字数 {{ outlineNum }}</div>
            </div>
        </div>
        <!-- 分卷内容 -->
        <div class="series_center" ref="editorOutline1" :class="isEditorMode ? '' : 'noEditor'">

            <!-- 第一次的手写分卷 -->
            <!-- <div class="series_center_text" v-if="editType === 1" :class="isEditorMode ? '' : 'noClick'">
                <el-input v-model="initWritForm.title" placeholder="请输入分卷标题" show-word-limit maxlength="50"></el-input>
                <el-input v-model="initWritForm.content" type="textarea" placeholder="请输入分卷内容" show-word-limit
                    maxlength="2000" :autosize="{ minRows: 6 }"></el-input>
            </div> -->
            <!-- 生成 -->
            <!-- <div v-if="editType == 2" :class="isEditorMode ? '' : 'noClick'">
                <editorLongOutlineList :is-edit="isEditorMode" :editType="editType" @del="delOutline"
                    :noveloutline="noveloutline" @getoutlineNum="getoutlineNum" @edit="editSeries" />
            </div> -->
            <!-- 编辑 -->
            <div v-if="editType == 3" :class="isEditorMode ? '' : 'noClick'">
                <editorLongOutlineList :is-edit="isEditorMode" :editType="editType" @del="delOutline"
                    :noveloutline="noveloutline" @getoutlineNum="getoutlineNum" @edit="editSeries" />
            </div>
            <!-- 续写分卷 -->
            <!-- <div v-if="editType == 4" :class="isEditorMode ? '' : 'noClick'">
                <editorLongOutlineList :is-edit="isEditorMode" :editType="editType" @del="delOutline"
                    :noveloutline="noveloutline" @getoutlineNum="getoutlineNum" @edit="editSeries" />
            </div> -->
        </div>
        <div class="series_bottom">
            <div>
                <el-button type="warning" @click="openEditor" v-if="!isEditorMode">编辑</el-button>
                <el-button type="warning" @click="save" plain v-if="isEditorMode">提交</el-button>
                <el-button type="warning" v-if="isShowBtn && !isLook" @click="next(2)">我有大纲</el-button>
                <el-button type="warning" v-if="isShowBtn && !isLook" @click="next(3)">AI生成大纲</el-button>
            </div>
        </div>
        <!-- 停止生成按钮 -->
        <AIStopCreate :hide="streamStatus"></AIStopCreate>
        <!-- 参考格式弹框 -->
        <tipPopup ref="tipPopup"></tipPopup>
        <!-- 警告提示框 -->
        <warnPopup ref="warnPopup"></warnPopup>
    </div>

</template>
<script>
import tipPopup from '@/components/tip_popup.vue'
import warnPopup from '@/components/warn_popup.vue'
import editorLongOutlineList from '@/components/long_novel/chapter/editor_long_outlineList.vue'
// import textRequire from '@/components/text_require.vue'// 要求
import { EventBus } from '@/utils/eventBus';
// import delPopup from '@/components/del_popup.vue';
// import textLoading from '@/components/text_loading.vue';
import { EncryptionUtil } from '@/utils/encrypt'
import { copy } from '@/utils/utils'
import api from '@/api/api';
import lNApi from '@/api/longNovel';
export default {
    components: {
        tipPopup,
        editorLongOutlineList,
        warnPopup,
        // delPopup,
        // textLoading,
        // textRequire,
    },
    data() {
        return {
            editType: null, //1我有大纲手动输入 2Ai生成 3编辑大纲 4续写章节
            ifheadEdit: false, //  true表示手动输入如：我有大纲和手动续写；false表示ai生成、编辑、续写章节
            ifSave: false, //是否保存
            outlineNum: 0, //大纲字数
            // 手动输入提示词
            handPlaceholder: '请长按粘贴或者输入您的大纲:大纲格式请参考”官方动态-我有大纲格式标准”',
            noveloutline: [], //小说大纲
            outlineItem: '', //Ai生成大纲
            streamCapture: [-1, -1],
            streamStatus: false, //流式请求
            streamIndex: 0, //流式请求下标
            debounceTimer: null, //防抖定时器
            textrequire: '',//作品要求
            isEditorMode: false, //false显示编辑 true显示保存
            isStop: false, //是否停止
            checked: false, //全选、反选
            isAiCreate: false,//是否ai去生成 true进入页面立即生成，false 表示不会刷新页面就生成
            hideEditorBtn: false,//false 默认不隐藏， true隐藏
            initWritForm: { // 第一次手写的对象内容
                title: '',
                content: ''
            },
            isShowBtn: false,
            isLook: false //只是查看
        }
    },
    created() {
        //换一换，下一步都是这个去监听
        EventBus.$on('getRequire', (item) => {
            console.log('监听换一换的作品要求=', item);
            this.noveloutline = []
            this.textrequire = item
            //换一换 初始化取消ai生成的状态
            this.isStop = false
            this.createOutline()
        })
        let editItem = JSON.parse(sessionStorage.getItem('editItem'))
        console.log('long大纲页面=', editItem)
        if (editItem) {
            this.editType = editItem.editType;
            this.isLook = editItem.isLook === true ? true : false;
            this.isAiCreate = editItem.isAiCreate === true ? true : false;
            if (this.editType === 3) {
                this.isShowBtn = editItem?.series.current
                this.getOutline()
            }
        } else {
            // this.$message.warning('不支持多开页面进行操作')
            // setTimeout(() => {
            //     window.location.href = 'about:blank'; // 跳转到空白页
            // }, 500);

        }
    },
    beforeDestroy() {
        EventBus.$off('getRequire')
        this.clearTimer()
    },
    methods: {
        //销毁定时器
        clearTimer(status) {
            console.log('进来了销毁定时器')
            if (status) {
                this.isStop = true
                this.hideEditorBtn = true //ai生成完成隐藏编辑里面的按钮
            }
            this.streamCapture = [-1, -1]
            this.outlineItem = ''
            clearTimeout(this.debounceTimer)
            this.streamStatus = false
            this.streamIndex = 0
            sessionStorage.removeItem('streamStatus');
        },
        //打开格式提示
        openTip() {
            this.$nextTick(() => {
                this.$refs.tipPopup.openPopup();
            })
        },

        //换一换ai生成
        changeOutline() {
            this.$refs.textRequire.openPrompt('series_outline', '')
        },
        //Ai生成大纲 和 换一换
        createOutline() {
            let editItem = JSON.parse(sessionStorage.getItem('editItem'))
            let params = {
                novelId: editItem.novelInfo.id,
                platform: 1,
                requirement: this.textrequire ? this.textrequire : ''
            }
            this.AIWrite({
                length: '长',
                haveId: true,
                type: 'series_outline',
                params: params,
                success: (res) => {
                    this.streamIndex = 0
                    this.streamStatus = true
                    sessionStorage.setItem('streamStatus', this.streamStatus)
                    sessionStorage.setItem('ifEditor', true)
                    this.hideEditorBtn = true //ai生成完成隐藏编辑里面的按钮
                    localStorage.setItem('AICreateId', res.data)
                    this.getStreamContent(res.data)
                },
                warn: (res) => {
                    this.$message.warning(res.msg)
                },
                error: () => {
                    this.streamStatus = false
                    sessionStorage.removeItem('streamStatus');
                }
            })
            // lNApi.longNovelHelpWriteId('series_outline',
            //     {
            //         novelId: editItem.novelInfo.id,
            //         platform: 1,
            //         requirement: this.textrequire ? this.textrequire : ''
            //     }
            // ).then((res) => {
            //     if (res.code == 200) {
            //         this.streamStatus = true
            //         sessionStorage.setItem('streamStatus', this.streamStatus)
            //         sessionStorage.setItem('ifEditor', true)
            //         this.hideEditorBtn = true //ai生成完成隐藏编辑里面的按钮
            //         localStorage.setItem('AICreateId', res.data)
            //         this.getStreamContent(res.data)
            //     } else {
            //         this.$message.warning(res.msg)
            //     }
            // }).catch(() => {
            //     this.streamStatus = false
            //     sessionStorage.removeItem('streamStatus');
            // })
        },

        getStreamContent(id) {
            // 清除之前的定时器
            if (this.debounceTimer) {
                clearTimeout(this.debounceTimer);
            }
            this.debounceTimer = setTimeout(() => {
                api.getStreamContent(id, this.streamIndex).then((res) => {
                    if (res.code === 200) {
                        if (res.data && res.data.length !== 0) {
                            this.streamIndex = this.streamIndex + res.data.length;
                            res.data.map((item) => {
                                if (item !== '[DONE]') {
                                    this.outlineItem += item
                                    this.streamCapture[0] = this.outlineItem.indexOf('{');
                                    this.streamCapture[1] = this.outlineItem.indexOf('}');

                                    if (this.streamCapture[0] !== -1 && this.streamCapture[1] !== -1) {
                                        const jsonStr = this.outlineItem.substring(this.streamCapture[0], this.streamCapture[1] + 1)
                                        this.outlineItem = this.outlineItem.replace(jsonStr, '')
                                        let chapterObj = this.escapeControlCharacters(jsonStr)
                                        const chapter = JSON.parse(chapterObj);
                                        let obj = {
                                            title: chapter.t,
                                            content: chapter.p
                                        }
                                        this.noveloutline.push(obj);
                                        this.scrollToBottom(); // 调用滚动方法
                                        this.streamCapture = [-1, -1]
                                    }
                                }
                            });
                            if (res.data[res.data.length - 1] === '[DONE]') {
                                this.streamIndex = 0
                                this.clearTimer()
                                //刷新用户信息-基础会员字符刷新
                                this.getUserInfo()
                                return
                            }
                            this.getStreamContent(id)
                        } else {
                            this.getStreamContent(id);
                        }
                    } else {
                        this.$message.warning(res.msg)
                        this.clearTimer()
                    }
                }).catch(() => {
                    this.streamStatus = false
                });
            }, 500);
        },
        escapeControlCharacters(str) {
            // eslint-disable-next-line no-control-regex
            return str.replace(/[\x00-\x1F\x7F-\x9F]/g, '')
        },
        // 滚动到内容底部
        scrollToBottom() {
            this.$nextTick(() => {
                const container = this.$refs.editorOutline1;
                if (container) {
                    container.scrollTop = container.scrollHeight; // 设置滚动位置到底部
                }
            });
        },
        //获取分卷详情
        getOutline() {
            let editItem = JSON.parse(sessionStorage.getItem('editItem'))
            lNApi.seriesDetail({ id: editItem.seriesId }).then((res) => {
                if (res.code == 200) {
                    if (res.data && Object.keys(res.data).length > 0) {
                        this.noveloutline = [res.data]
                    }
                }
            })
        },

        //获取大纲字数
        getoutlineNum(item) {
            this.outlineNum = item.num
            this.noveloutline = item.list
        },
        //打开编辑
        openEditor() {
            if (this.streamStatus) {
                this.$message.warning('请等待Ai生成完成！');
                return
            }
            sessionStorage.setItem('ifEditor', true)
            this.isEditorMode = true
            this.ifSave = false
        },
        //下一步生成章纲
        next(i) {
            if (this.noveloutline.length > 0) {
                let editItem = JSON.parse(sessionStorage.getItem('editItem'))
                //手写
                if (i === 2) {
                    this.$router.replace({ path: '/chapterOutlineImport', query: { novelInfo: EncryptionUtil.encrypt(editItem.novelInfo), successNovelId: editItem.novelInfo.id, series: EncryptionUtil.encrypt(editItem?.series), seriesId: editItem?.series.id } })
                    return
                }
                //ai生成
                if (i === 3) {
                    editItem = {
                        id: editItem.id,
                        novelInfo: editItem.novelInfo,
                        editType: 2,
                        seriesId: editItem.seriesId,
                        series: editItem.series,
                        seriesNum: editItem?.series.seriesNum,
                        isShowZG: editItem.isShowZG,
                        isAiCreate: true,//表示是不是ai生成，ai续写的不算，目的是为了不让别在浏览器复制地址多开当前ai生成页面一直生成问题
                    }
                    sessionStorage.setItem('editItem', JSON.stringify(editItem));
                    this.$router.replace({ path: '/chapterOutline' })
                    return
                }


                // let editItem = JSON.parse(sessionStorage.getItem('editItem'))
                // editItem = {
                //     id: editItem.id,
                //     novelInfo: editItem.novelInfo,
                //     editText: i,
                //     seriesId:editItem.seriesId,
                //     series:editItem.series,
                //     seriesNum: editItem?.series.seriesNum,
                //     isAiCreate: i === 3? true : false,//表示是不是ai生成，ai续写的不算，目的是为了不让别在浏览器复制地址多开当前ai生成页面一直生成问题
                // }
                // sessionStorage.setItem('editItem', JSON.stringify(editItem));
                // window.location.reload()
            }
        },
        //保存大纲
        confirmOutline() {
            const editItem = JSON.parse(sessionStorage.getItem('editItem'));
            //修改分卷内容
            if (this.noveloutline.length > 0) {
                if (!this.noveloutline[0].title || !this.noveloutline[0].content) {
                    this.$message.warning('分卷标题内容不能为空')
                    return
                }
                lNApi.seriesUpdate(this.noveloutline[0]).then((res) => {
                    if (res.code === 200) {
                        editItem.backNum = 1
                        this.ifSave = true
                        this.$message.success('分卷内容修改成功！');
                        //保存大纲后，不可编辑
                        this.isEditorMode = false
                        //保存后可以出现手动续写和ai编辑
                        this.isStop = false
                        //ai生成完成隐藏编辑里面的按钮
                        this.hideEditorBtn = false
                        sessionStorage.setItem('editItem', JSON.stringify(editItem))
                        sessionStorage.removeItem('streamStatus');
                        sessionStorage.setItem('ifEditor', false)
                        this.getOutline()
                    } else {
                        this.$message.warning(res.msg)
                    }
                });
            }

        },
        // 保存大纲
        save() {
            if (this.streamStatus) {
                this.$message.warning('请等待Ai生成完成！');
                return
            }
            if (this.isStop) {
                this.cancelAi().then(() => {
                    this.confirmOutline()
                })
            } else {
                this.confirmOutline()
            }
        },
        //删除大纲
        delOutline(data) {
            if (this.streamStatus) {
                this.$message.warning('请等待Ai生成完成！');
                return
            }
            let text = ''
            if (data.index === this.noveloutline.length - 1) {
                text = `是否需要删除从第${data.index + 1}分卷，删除后无法恢复，请慎重操作`
            } else {
                text = `是否需要删除从第${data.index + 1}分卷到后面所有的分卷，删除后对应的分卷和章节都会删除，且无法恢复，请慎重操作`
            }
            this.$confirm(text, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                //如果当前有id说明是已经存在的，如果没有id说明是刚ai生成的
                // console.log('data=', data)
                if (data.id !== -1) {
                    // lNApi.delNovelOutline({ id: data.id }).then(res => {
                    //     if (res.code === 200) {
                    //         this.$message.success('删除成功')
                    //         this.noveloutline = this.noveloutline.filter((_, i) => i < data.index) // 从当前索引开始删除所有后续元素
                    //         this.novleEmptyIsToPath()
                    //     }
                    // })
                } else {
                    this.noveloutline = this.noveloutline.filter((_, i) => i < data.index) // 从当前索引开始删除所有后续元素
                    this.$message.success('删除成功')
                    this.novleEmptyIsToPath()
                }
            })
        },
        //如果删除后没有内容就跳转到入口页面
        novleEmptyIsToPath() {
            if (!this.noveloutline.length) {
                let editItem = JSON.parse(sessionStorage.getItem('editItem'));
                console.log('editItem=', editItem)
                editItem.backNum = 2
                editItem.editText = ''
                sessionStorage.setItem('editItem', JSON.stringify(editItem));
                // this.$router.replace('/novel')
                this.$router.go(-1)
            }
        },
        // 复制正文
        async copyInnterText() {
            if (this.streamStatus) {
                this.$message.warning('请等待Ai生成完成！');
                return
            }
            let text = ''
            if ([1].includes(this.editType)) {
                text = ''
            } else if ([2, 3, 4].includes(this.editType)) {
                text = this.noveloutline.reduce((count, item) => {
                    return count + '\n' + item.title + '\n' + item.content
                }, '')
                text += ''
            }
            const success = await copy(text);
            if (success) {
                this.$message.success('复制成功');
            } else {
                this.$message.error('复制失败');
            }
        },
        //修改
        editSeries(data) {
            this.$refs.seriesWrite.editInfo({ ...data.item, seriesIndex: data.index, name: '编辑分卷' })
        }
    }
}
</script>
<style lang="scss" scoped>
.series-main {
    width: 100%;
    height: 100%;
    background: #fff;
    display: flex;
    flex-direction: column;
    overflow: auto;
}

.series_top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 67px;
    padding: 0 40px;
    border-bottom: 1px solid #e6ebf0;
    flex-shrink: 0;

    .series_top_left {
        .series_top_title {
            font-weight: 700;
            font-size: 19px;
            color: #111;
            margin-right: 10px;
        }

        .series_top_tip {
            display: flex;
            align-items: center;
            font-size: 15px;
            color: #333;
        }
    }

    .series_top_center {
        font-size: 15px;
        color: #444;
    }

    .series_top_right {
        .series_top_num {
            font-size: 15px;
            color: #444;
        }
    }
}

.series_center {
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: auto;
    padding: 15px 20px;
    @include scrollbar();

    &:hover {
        @include scrollbar_hover();
    }

    .series_center_text {
        ::v-deep(.el-input__inner) {
            border: 0;
        }

        ::v-deep(.el-textarea__inner) {
            border: 0;
        }
    }
}

.series_bottom {
    flex-shrink: 0;
    height: 69px;
    border-top: 1px solid #e6ebf0;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>